import type { TrafficCoverageLevel } from '@hotjar/webapp/domains/revenue/sampling/types';

import { BaseTarget } from './BaseTarget';
import type { BaseAttributes } from './BaseTarget';

export interface TrafficTargetAttributes extends BaseAttributes {
  id?: number;
  coverageLevel?: TrafficCoverageLevel;
  isCoverageMeasureComplete?: boolean;
  isCoverageVeryLow?: boolean;
  days?: number;
}

class TrafficCoverageTarget extends BaseTarget {
  trafficData: TrafficTargetAttributes;

  constructor(trafficData: TrafficTargetAttributes) {
    super({ id: trafficData.id });
    this.trafficData = trafficData;
  }

  // FIXME: Consider using a static method.
  // eslint-disable-next-line class-methods-use-this
  get prefix(): string {
    return 'site';
  }

  get attributes(): TrafficTargetAttributes {
    return this.trafficData;
  }
}

export { TrafficCoverageTarget };
